export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11112.5630ce3d.jpg";